import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 9px;
    border: ${props =>('2px solid ' + props.color)};
    flex-direction: column;
    @media (min-width: 1000px) {
        flex-direction: row;
    }
`;

export const ContainerGraph = styled.div`
    display: flex;
    width: 100%; 
    justify-content: center;
    align-items: center; 
    @media (min-width: 1000px) {
        width: 80%; 
    }
`;

export const LegendContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    min-width: 190px;
    padding: 10px;
    gap: 10px;
    @media (min-width: 1000px) {
        width: 20%; 
    }
`;

export const ContainerName = styled.div`
    border-radius: 5px;
    background: #FFF;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    width: 100%;
    padding: 20px;
    color: #333;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const Variablesindicator = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 10px;
`;

export const VariableLegend = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 20px;
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    @media (min-width: 1000px){
        justify-content: flex-start;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

export const VariableColor = styled.div`
    display: flex;
    background: ${props=>(props.$color)};
    width: 33.555px;
    height: 33.555px;
    min-width: 33.555px;
    min-height: 33.555px;
    border-radius: 3.507px;
`;

export const ButtonTime = styled.button`
    width: 115.023px;
    height: 27.691px;
    border-radius: 4.92px;
    background: ${props =>(props.$selected ? '#006560' : '#F2F2F2')};
    box-shadow: 2.237px 2.237px 2.952px 0px rgba(43, 73, 133, 0.25);
    border: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    color: ${props =>(props.$selected ? '#F2F2F2' : '#333')};;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 116.508%; /* 18.641px */
`;

export const TimeSelector = styled.select`
    display: flex;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    cursor: pointer;
    outline: none;
    background: #fff;
    padding: 20px 25px;
    border: 1px solid #006560;
`;

export const StyledOption = styled.option`
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-weight: 700; 
    font-style: normal;
    text-align: start;
    line-height: 0;
`;

export const ScaleText = styled.h1`
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    text-align: left;
    max-width: 100%;
`;